import * as yup from 'yup';

export const lodgeReturnApplicationSchema = yup.object().shape({
  taxYear: yup
    .number()
    .typeError('Tax year must be a number')
    .required('Tax year is required')
    .integer('Tax year must be an integer')
    .min(2000, 'Tax year must be after 2000')
    .max(new Date().getFullYear(), `Tax year cannot be in the future`),
  income: yup.array().required('Please select any option.'),
  jointlyOwnedProperties: yup.boolean().required('Please select any option.'),
  firstName: yup.string().required('Please enter your first name.'),
  lastName: yup.string().required('Please enter your last name.'),
  email: yup
    .string()
    .email('Please enter a valid email address.')
    .required('Please enter your email address.'),
  phone: yup.string().required('Please enter your number.'),
  country: yup.string().required('Please enter your country.'),
  australianTaxFileNumber: yup
    .string()
    .required('Please write the tax file number.'),
  dateOfBirth: yup.string().required('Please select any option.'),
  agreeToTerms: yup.boolean().required('Please agree to the terms.'),
});
